import PropTypes from "prop-types";
import React from "react";
import { LayoutContext } from "./LayoutContext";

const LayoutPropertiesSetter = React.memo((
  {
    setVerticalPosition, setHorizontalPosition, setFullHeight,
    verticalPosition, horizontalPosition, fullHeight,
  }) => {
  React.useEffect(() => {
    setVerticalPosition(verticalPosition);
    // return () => setVerticalPosition(undefined);
  }, [ setVerticalPosition, verticalPosition ]);

  React.useEffect(() => {
    setHorizontalPosition(horizontalPosition);
    // return () => setHorizontalPosition(undefined);
  }, [ setHorizontalPosition, horizontalPosition ]);

  React.useEffect(() => {
    setFullHeight(fullHeight);
    // return () => setFullHeight(undefined);
  }, [ setFullHeight, fullHeight ]);

  return null;
});

export const LayoutProperties = React.memo((props) => {
  return (
    <>
      <LayoutContext.Consumer>
        {(setters) => <LayoutPropertiesSetter {...setters} {...props} />}
      </LayoutContext.Consumer>
      {props.children}
    </>
  );
});

LayoutProperties.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  verticalPosition: PropTypes.oneOf([ "top", "middle", "bottom" ]),
  horizontalPosition: PropTypes.oneOf([ "left", "center", "right" ]),
  fullHeight: PropTypes.bool,
};

LayoutProperties.defaultProps = {
  children: undefined,
  verticalPosition: undefined,
  horizontalPosition: undefined,
  fullHeight: undefined,
};
